import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { SiteProvider } from "./context/SiteContext";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import TopBar from "./components/TopBar";
import ScrollToTop from "./components/ScrollToTop";
import RedirectHandler from "./components/RedirectHandler";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import HowToPlay from "./pages/HowToPlay";
import CricketID from "./pages/CricketID";
import Casino from "./pages/Casino";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ResponsibleGambling from "./pages/ResponsibleGambling";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import DynamicPage from "./pages/DynamicPage";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/toaster";

import AdminLayout from "./pages/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import PostsList from "./pages/admin/PostsList";
import PostEditor from "./pages/admin/PostEditor";
import PagesList from "./pages/admin/PagesList";
import PageEditor from "./pages/admin/PageEditor";
import AdminSettings from "./pages/admin/AdminSettings";
import Submissions from "./pages/admin/Submissions";
import Redirects from "./pages/admin/Redirects";

function PublicShell({ children }) {
  return (
    <>
      <TopBar />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <FloatingButtons />
    </>
  );
}

function App() {
  return (
    <div className="App bg-background min-h-screen">
      <HelmetProvider>
        <AuthProvider>
          <SiteProvider>
            <BrowserRouter>
              <ScrollToTop />
              <RedirectHandler />
              <Routes>
                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="posts" element={<PostsList />} />
                  <Route path="posts/:id" element={<PostEditor />} />
                  <Route path="pages" element={<PagesList />} />
                  <Route path="pages/:id" element={<PageEditor />} />
                  <Route path="settings" element={<AdminSettings />} />
                  <Route path="submissions" element={<Submissions />} />
                  <Route path="redirects" element={<Redirects />} />
                </Route>

                {/* Public */}
                <Route path="/" element={<PublicShell><Home /></PublicShell>} />
                <Route path="/cricket-id" element={<PublicShell><CricketID /></PublicShell>} />
                <Route path="/casino" element={<PublicShell><Casino /></PublicShell>} />
                <Route path="/how-to-play" element={<PublicShell><HowToPlay /></PublicShell>} />
                <Route path="/about-us" element={<PublicShell><About /></PublicShell>} />
                <Route path="/contact-us" element={<PublicShell><Contact /></PublicShell>} />
                <Route path="/blog" element={<PublicShell><Blog /></PublicShell>} />
                <Route path="/blog/:slug" element={<PublicShell><BlogPost /></PublicShell>} />
                <Route path="/responsible-gambling" element={<PublicShell><ResponsibleGambling /></PublicShell>} />
                <Route path="/terms-of-service" element={<PublicShell><Terms /></PublicShell>} />
                <Route path="/privacy-policy" element={<PublicShell><Privacy /></PublicShell>} />
                <Route path="/p/:slug" element={<PublicShell><DynamicPage /></PublicShell>} />
                <Route path="/home" element={<Navigate to="/" replace />} />
                <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
              </Routes>
              <Toaster />
            </BrowserRouter>
          </SiteProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
